import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SignupRequest } from 'src/app/auth/models/signup';
import { AccountType } from 'src/app/auth/models/user';

import { AlertService } from 'src/app/auth/services/alert.service';

import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { environment } from 'src/environments/environment';
import { throwError } from 'rxjs';
import { SignupService } from 'src/app/auth/services/signup.service';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { BillingLevel, BILLINGLEVELOPTIONS } from 'src/app/utils/billingLevel';
import { GoogleAnalytics } from 'src/app/services/google-analytics.service';
import { BrazeService } from 'src/app/services/braze.service';

@Component({
  selector: 'app-review-signup',
  templateUrl: './review-signup.component.html',
  styleUrls: ['./review-signup.component.scss'],
})
export class ReviewSignupComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup;
  @Input() displayCurrency: CurrencyState;
  @Output() completeSubmit = new EventEmitter<any>();
  accountType = AccountType;
  billingLevel = BillingLevel;
  featureCost: number;
  trialPeriod = environment.trialPeriod;
  featureLevel: string;
  emailFormControls: any;
  billingFormControls: any;
  accountFormControls: any;
  signupFormValue: any;
  isFormValid: boolean;
  isloading: boolean;

  pattern = {
    P: {
      pattern: new RegExp('\\d'),
    },
  };

  phoneMask = ['PPP-PPP-PPPP', this.pattern];
  private sm = new SubscriptionManager();

  constructor(
    private brazeService: BrazeService,
    private signupService: SignupService,
    private alertService: AlertService,
    private changeDetectorRef: ChangeDetectorRef,
    private googleAnalytics: GoogleAnalytics
  ) {}

  ngOnInit(): void {
    this.parentForm.valueChanges.subscribe((val) => {
      this.signupFormValue = val;
      this.featureLevel = val?.featureLevel;
      this.billingFormControls = val?.billingForm;
      this.emailFormControls = val?.checkEmailAddress;
      this.accountFormControls = val?.accountForm;
      this.featureCost = BILLINGLEVELOPTIONS.find(
        (F) => F.name === this.featureLevel
      )?.cost;
    });
    this.parentForm.statusChanges.subscribe((val) => {
      if (val === 'VALID') {
        this.isFormValid = true;
      } else {
        this.isFormValid = false;
      }
    });
  }
  submitForm() {
    this.isloading = true;
    this.alertService.clear();
    const data: SignupRequest = {
      city: this.billingFormControls?.city,
      state: this.billingFormControls?.stateProvince,
      country: this.billingFormControls?.country,
      featureLevel: this.featureLevel,
      price:
        this.featureLevel === this.billingLevel.TRIAL
          ? this.featureCost
          : Number(this.billingFormControls?.totalCostPerMonth),
      userExists: false,
      numberOfUsers: this.billingFormControls?.noOfUsers,
      card: {
        name: this.billingFormControls?.cardHolderName,
        expMonth: this.billingFormControls?.expirationMonth,
        expYear: this.billingFormControls?.expirationYear,
        cvv: this.billingFormControls?.cvv,
        number: this.billingFormControls?.cardNumber,
        type: this.billingFormControls?.cardType,
      },
      numberOfTrucks: this.accountFormControls?.noOfTrucks,
      userName: this.accountFormControls?.emailAddress,
      // hardcoded SSO password for TID authentication
      password: 'PCMPassword@1234',
      companyName: this.accountFormControls?.companyName,
      companyType: this.accountFormControls?.companyType,
      firstName: this.accountFormControls?.firstName,
      lastName: this.accountFormControls?.lastName,
      jobTitle: this.accountFormControls?.jobTitle,
      address1: this.billingFormControls?.address1,
      address2: this.billingFormControls?.address2,
      postalCode: this.billingFormControls?.zipCode,
      phoneNumber: this.billingFormControls?.phone,
      CardHolderName: this.billingFormControls?.cardHolderName,
      CardType: this.billingFormControls?.cardType,
      CardNumber: this.billingFormControls?.cardNumber,
      ExpirationMonth: this.billingFormControls?.expirationMonth,
      ExpirationYear: this.billingFormControls?.expirationYear,
      CVV: this.billingFormControls?.cvv,
    };

    this.sm.manage = this.signupService.signup(data).subscribe(
      () => {
        localStorage.removeItem('userExists');
        this.isloading = false;
        this.completeSubmit.emit(true);
        this.googleAnalytics.addGA(
          'Signup_Submitted',
          'Signup_click',
          'Signup',
          `${this.featureLevel} account signup success`
        );
      },
      (err) => {
        this.isloading = false;
        this.changeDetectorRef.detectChanges();
        this.parentForm.controls.accountForm.markAsPristine();
        const error = err.error
          ? err.error.toString().split(':')[1] || err.error
          : err?.ModelState?.vm;
        this.alertService.error(error, false, 'app-modal-alert', true);
        setTimeout(() => {
          this.scrollTo();
        }, 0);
        return throwError(err);
      },
      () => {
        this.brazeService.trackSignup(data);
      }
    );
  }

  scrollTo(): void {
    const elementList = document.querySelectorAll('.fixedPageAlert');
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
  }
  maskCreditCard(card: string): string {
    if (card) {
      return card
        .replace(/.(?=.{4})/g, 'X')
        .match(/.{1,4}/g)
        .join(' ');
    }
  }
  ngOnDestroy(): void {
    this.sm.unsubscribe();
  }
}
